export default {"src":"/_next/static/media/0xae461ca67b15dc8dc81ce7615e0320da1a9ab8d5.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};